

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';

const routes: Routes = [
  {
    path: 'account',
    loadChildren: () =>
      // import('./account/account.module').then((m) => m.AccountModule),
      import('./account/account.module').then((m)=>m.AccountModule)
  },

  {
    path: '',
    component: LayoutComponent,
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}

  // {
  //   path: 'sysadmin',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import('./pages/sysadmin/sysadmin.module').then((m) => m.SysadminModule),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'digiadmin',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import('./pages/digiadmin/digi-admin.module').then(
  //       (m) => m.DigiAdminModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'lbc',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import('./pages/lbc/lbc.module').then(
  //       (m) => m.LbcModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'qcc',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import('./pages/qcc/qcc.module').then(
  //       (m) => m.QccModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'qccdistrict',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import('./pages/qcc-district/qcc-district.module').then(
  //       (m) => m.QccDistrictModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'itdistrict',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import('./pages/itdistrict/itdistrict.module').then(
  //       (m) => m.ItdistrictModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'itregion',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import('./pages/itregion/itregion.module').then(
  //       (m) => m.ItregionModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'head',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import('./pages/head/head.module').then(
  //       (m) => m.HeadModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'super',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import('./pages/super/super.module').then(
  //       (m) => m.SuperModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'admin',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import('./pages/admin/admin.module').then(
  //       (m) => m.AdminModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'ched_district',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import('./pages/ched-district/ched-district.module').then(
  //       (m) => m.ChedDistrictModule
  //     ),
  //   canActivate: [AuthGuard],
  // },
// import { NgModule } from '@angular/core';
// import { Routes, RouterModule } from '@angular/router';

// import { AuthGuard } from './core/guards/auth.guard';
// import { LayoutComponent } from './layouts/layout.component';

// const routes: Routes = [
//   { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
//   // tslint:disable-next-line: max-line-length
//   { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
  
// ];

// @NgModule({
//   imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy' })],
//   exports: [RouterModule]
// })

// export class AppRoutingModule { }